import React from "react";
import Image from "next/image";

interface Card {
  title: string;
  image: {
    data: {
      attributes: {
        url: string;
      };
    };
  };
}
interface Block {
  Card: Card[];
  title: string;
  sub_title: string;
  short_title: string;
  description: string;
}
interface Props {
  block: Block;
}
const WhatWeBelieve: React.FC<Props> = ({ block }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[150px] pb-[56px] lg:pb-[80px] xl:pb-[100px] relative z-0 overflow-hidden">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>

          <div className="container">
            <div className="heading xl:mb-[60px] md:mb-[50px] mb-[30px] relative z-2">
              <h2 className="text-heading-1 font-bold text-white text-center mb-[12px]">
                {block?.short_title ?? ""}
              </h2>
              <h6 className="text-heading-6 font-regular text-gray-50 mb-[0px] text-center">
                {block?.title ?? ""}
              </h6>
            </div>

            <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-[20px] relative z-2">
              {block?.Card?.map((card, index) => (
                <div
                  key={"card" + index}
                  className="card-vision border border-gray-700 group flex flex-col justify-between *:"
                >
                  <div className="p-[32px_20px_80px_20px] lg:p-[32px_20px_100px_20px]">
                    <h3 className="text-heading-6 font-bold text-white">
                      {card?.title}
                    </h3>
                  </div>
                  <div className="border-l-[32px] border-[#8AC7F4] overflow-hidden card-vision-border">
                    <Image
                      src={
                        card?.image?.data?.attributes?.url
                          ? baseUrl + card.image.data.attributes.url
                          : "/images/leadership/vision-card-1.png"
                      }
                      alt={"Strategy Image" + (index + 1)}
                      width={358}
                      height={220}
                      className="w-full h-[220px] 2xl:h-[260px] group-hover:scale-[1.1] transition-all duration-500 ease-in-out"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatWeBelieve;
